import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import styled from "styled-components";
import TableActionButton from "../../../../@ui/TableActionButton";
import TriggerImportModal from "../../../modal/LayerAdmin/RouteLine/TriggerImportModal";
import RouteLineService from "../../../../services/RouteLineService";

const StyledIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
`;

interface TriggerImportProps {
  service: RouteLineService;
  onSubmitted: () => void;
}

const TriggerImport = ({ service, onSubmitted }: TriggerImportProps) => {
  const [show, setShow] = useState(false);
  const [submitting, setIsSubmitting] = useState(false);
  const [errored, setErrored] = useState(false);

  const handleSubmit = (quarter: string, file?: File | null) => {
    if (file != null) {
      setIsSubmitting(true);
      service
        .StartRouteLineImport(file, quarter)
        .then(() => {
          setShow(false);
          onSubmitted();
        })
        .catch(() => {
          setErrored(true);
        });
    }
  };

  return (
    <>
      <TableActionButton onClick={() => setShow(true)}>
        <StyledIcon icon={faPlus} />
        Trigger Import
      </TableActionButton>
      <TriggerImportModal
        onSubmit={handleSubmit}
        onClose={() => setShow(false)}
        show={show}
        isSubmitting={submitting}
        hasErrored={errored}
      />
    </>
  );
};

export default TriggerImport;
